// frontend/src/pages/MeuDesempenhoPage/MeuDesempenhoPage.jsx

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './MeuDesempenhoPage.css';
// Importações Financeiras
import { getFullDashboardData, getContas, getCartoes, getProximasFaturas, getTodosCartoesAdicionais } from '../../services/financeService';
import { createOrUpdateMetaFaturamento } from '../../services/metaService';
import { getPerfil, updatePerfil } from '../../services/userService';
// Importações de Milhas
import { getDesempenhoMilhas, getPortadores, getMilhasRecebiveis, getControleCpfs } from '../../services/milhasService';
import LogoManager from '../../components/LogoManager/LogoManager';
// Contexto para atualização automática
import { useDataRefresh } from '../../contexts/DataRefreshContext';
import { usePrivacy } from '../../contexts/PrivacyContext';
import { useAuth } from '../../contexts/AuthContext';
// 1. IMPORTAÇÃO DO TRATAMENTO DE ERRO
import { getErrorMessage } from '../../utils/errorHandler';
import { currencyInputProps } from '../../utils/numberInputMask';
import {
    DESEMPENHO_CARD_GROUPS,
    buildPreferenciasUiPatch,
    getDesempenhoCardsMap,
    isCardVisible,
} from '../../utils/desempenhoCards';
import {
    getDesempenhoFiltros,
    contarFiltrosAtivos,
    buildFiltrosPatch,
} from '../../utils/desempenhoFiltros';
import {
    getInsightsDismissedMap,
    dismissInsightInMap,
    restoreInsightIdsInMap,
    buildInsightsDismissedPatch,
} from '../../utils/insightsDismiss';
import { chartPalette } from '../../styles/brandColors';

import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import SeletorDeMes from '../../components/SeletorDeMes/SeletorDeMes';
import PrimeirosPassosCard from '../../components/PrimeirosPassosCard/PrimeirosPassosCard';
import InsightsFinanceirosCard from '../../components/InsightsFinanceirosCard/InsightsFinanceirosCard';
import ModoPrestadorBanner from '../../components/ModoPrestadorBanner/ModoPrestadorBanner';
import DesempenhoFiltrosModal from '../../components/DesempenhoFiltrosModal/DesempenhoFiltrosModal';
import { Card, Row, Col, Statistic, Spin, Tooltip as AntdTooltip, Space, Typography, Divider, Select, message, Tag, Tabs, List, Segmented, Progress, Button, Modal, Form, InputNumber, Switch, Badge } from 'antd';
import {
    WalletOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    StarOutlined,
    DollarCircleOutlined,
    QuestionCircleOutlined,
    BankOutlined,
    RiseOutlined,
    RocketOutlined,
    SafetyCertificateOutlined,
    WarningOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined,
    ScheduleOutlined,
    AppstoreOutlined,
    FilterOutlined,
} from '@ant-design/icons';

import {
    PieChart, Pie, Cell, ResponsiveContainer, Tooltip,
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, LineChart, Line, Area
} from 'recharts';

dayjs.locale('pt-br');

const { Title, Text } = Typography;
const { Option } = Select;

const REGIME_STORAGE_KEY = 'financeiro.regime';
const REGIME_LEGACY_KEY = 'metas.regime';
const REGIME_COMPETENCIA = 'competencia';
const REGIME_FATURA = 'fatura';

const REGIME_OPTIONS = [
    { label: 'Quando gastei', value: REGIME_COMPETENCIA },
    { label: 'Quando a fatura vence', value: REGIME_FATURA },
];

const REGIME_HELP = {
    [REGIME_COMPETENCIA]:
        'Conta o que você gastou neste mês (data da compra), mesmo que o cartão vença depois. Saldo em contas continua em regime de caixa.',
    [REGIME_FATURA]:
        'Conta pelo pagamento e pelo vencimento da fatura do cartão (quando o compromisso cai no mês).',
};

function loadRegimePreferidoDesempenho() {
    try {
        const saved = localStorage.getItem(REGIME_STORAGE_KEY);
        if (saved === REGIME_COMPETENCIA || saved === REGIME_FATURA) return saved;
        const legacy = localStorage.getItem(REGIME_LEGACY_KEY);
        if (legacy === REGIME_COMPETENCIA || legacy === REGIME_FATURA) {
            localStorage.setItem(REGIME_STORAGE_KEY, legacy);
            return legacy;
        }
    } catch (_) {
        /* ignore */
    }
    return REGIME_FATURA;
}


// --- FUNÇÕES AUXILIARES ---
const formatCurrency = (value) => {
    const number = parseFloat(value) || 0;
    return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

const formatNumber = (value) => {
    const number = parseFloat(value) || 0;
    return number.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

const HelpTip = ({ title }) => (
    <AntdTooltip title={title}>
        <QuestionCircleOutlined
            style={{ color: 'rgba(0, 0, 0, 0.45)', cursor: 'help' }}
            onClick={(e) => e.stopPropagation()}
        />
    </AntdTooltip>
);

const TitleWithHelp = ({ children, help }) => (
    <Space size={6}>
        {children}
        <HelpTip title={help} />
    </Space>
);

/** Linhas label | valor — legível no mobile com valores em R$. */
const MetricRows = ({ items }) => (
    <div className="planejamento-metric-rows">
        {items.map((item) => (
            <div key={item.label} className="planejamento-metric-row">
                <span className="planejamento-metric-label">
                    {item.dot ? (
                        <span
                            className="planejamento-metric-dot"
                            style={{ background: item.dot }}
                        />
                    ) : null}
                    {item.label}
                </span>
                <span
                    className="planejamento-metric-value"
                    style={item.color ? { color: item.color } : undefined}
                >
                    {item.value}
                </span>
            </div>
        ))}
    </div>
);

// ===================================================================================
// ALTERAÇÃO: REMOVIDO AGRUPAMENTO "OUTROS"
// ===================================================================================
// Agora a função apenas ordena os dados por valor decrescente, 
// mostrando TODAS as categorias independentemente do tamanho.
const processPieData = (data) => {
    if (!data || data.length === 0) return [];
    
    // Retorna uma cópia ordenada do maior para o menor valor
    return [...data].sort((a, b) => b.value - a.value);
};
// ===================================================================================

const CustomPieTooltip = ({ active, payload }) => {
    const { isPrivate } = usePrivacy();

    if (active && payload && payload.length) {
        const data = payload[0].payload;
        const containerStyle = {
            backgroundColor: 'rgba(33, 33, 33, 0.9)', border: 'none',
            borderRadius: '4px', padding: '8px 12px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        };
        const textStyle = { color: '#FFFFFF', margin: 0, fontSize: '12px' };
        const headerStyle = { ...textStyle, fontWeight: 'bold', paddingBottom: '4px' };

        return (
            <div className="custom-tooltip" style={containerStyle}>
                <p style={headerStyle}>{data.name}</p>
                <p style={textStyle}>{isPrivate ? '****' : formatCurrency(data.value)}</p>
            </div>
        );
    }
    return null;
};

const CustomChartTooltip = ({ active, payload, label }) => {
    const { isPrivate } = usePrivacy();

    if (active && payload && payload.length) {
        const containerStyle = {
            backgroundColor: 'rgba(33, 33, 33, 0.9)', border: 'none',
            borderRadius: '4px', padding: '8px 12px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        };
        const textStyle = { color: '#FFFFFF', margin: 0, fontSize: '12px' };
        const labelStyle = { ...textStyle, fontWeight: 'bold', paddingBottom: '4px' };

        return (
            <div style={containerStyle}>
                <p style={labelStyle}>{label}</p>
                {payload.map((pld, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '10px', height: '10px', backgroundColor: pld.color || pld.fill, marginRight: '8px' }}></div>
                        <p style={textStyle}>{`${pld.name}: ${isPrivate ? '****' : formatCurrency(pld.value)}`}</p>
                    </div>
                ))}
            </div>
        );
    }
    return null;
};

/**
 * "↑ 12% vs set" sob um KPI. maiorEhBom define a cor (receita subindo = verde,
 * despesa subindo = vermelho). Sem base no mês anterior, não mostra nada.
 */
const VariacaoMes = ({ atual, anterior, maiorEhBom, mesAnteriorLabel, isPrivate }) => {
    const base = Number(anterior) || 0;
    if (isPrivate || base <= 0) return null;
    const pct = ((Number(atual) || 0) - base) / base * 100;
    const arred = Math.round(pct);
    if (arred === 0) {
        return (
            <div className="desempenho-kpi-variacao">
                Igual a {mesAnteriorLabel}
            </div>
        );
    }
    const subiu = arred > 0;
    const bom = subiu === maiorEhBom;
    return (
        <div className={`desempenho-kpi-variacao ${bom ? 'is-bom' : 'is-ruim'}`}>
            {subiu ? '↑' : '↓'} {Math.abs(arred)}% vs {mesAnteriorLabel}
        </div>
    );
};

// --- COMPONENTES DOS GRÁFICOS ---

const EmptyChartState = ({ message }) => (
    <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'var(--color-text-secondary, #5A6A6A)', zIndex: 1
    }}>
        {message}
    </div>
);

// --- COMPONENTES DOS GRÁFICOS AGORA RECEBEM isPrivate ---
const DespesasCategoriaChart = ({ data, loading, onSelect }) => {
    const { isPrivate } = usePrivacy();
    const COLORS = chartPalette;

    const chartData = useMemo(() => processPieData(data), [data]);
    const total = chartData.reduce((acc, entry) => acc + entry.value, 0);

    if (loading) return <div style={{ height: 350, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin /></div>;

    return (
        <div className="chart-container-responsive">
            <style>{`
                .chart-container-responsive {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: auto;
                    min-height: 400px;
                }
                .chart-area {
                    width: 100%;
                    height: 250px;
                }
                .legend-area {
                    width: 100%;
                    padding-top: 16px;
                    display: flex;
                    flex-direction: column;
                    max-height: 200px;
                }
                @media (min-width: 992px) {
                    .chart-container-responsive {
                        flex-direction: row;
                        align-items: center;
                        height: 300px;
                        min-height: 300px;
                    }
                    .chart-area {
                        width: 55%;
                        height: 100%;
                    }
                    .legend-area {
                        width: 45%;
                        padding-left: 16px;
                        padding-top: 0;
                        height: 100%;
                        max-height: 100%;
                    }
                }
            `}</style>

            {chartData.length === 0 && <EmptyChartState message="Sem despesas para exibir." />}

            <div className="chart-area" style={{ opacity: chartData.length === 0 ? 0.3 : 1 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Tooltip content={<CustomPieTooltip />} />
                        <Pie
                            data={chartData} cx="50%" cy="50%" labelLine={false} label={false}
                            outerRadius={80} innerRadius={40} dataKey="value" nameKey="name"
                            paddingAngle={1} stroke="#FFFFFF" strokeWidth={2} minAngle={6}
                            onClick={(_, index) => onSelect?.(chartData[index])}
                            style={onSelect ? { cursor: 'pointer' } : undefined}
                        >
                            {chartData.map((entry, index) => (<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className="legend-area">
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    {chartData.map((entry, index) => (
                        <div
                            key={index}
                            className={onSelect && entry.categoria_ids?.length ? 'desempenho-categoria-linha is-clicavel' : 'desempenho-categoria-linha'}
                            onClick={() => onSelect?.(entry)}
                        >
                            <div style={{ width: '10px', height: '10px', backgroundColor: COLORS[index % COLORS.length], marginRight: '8px', borderRadius: '50%', flexShrink: 0 }}></div>
                            <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                <Text style={{ fontSize: '12px' }} title={entry.name}>{entry.name}</Text>
                            </div>
                            <Text style={{ fontSize: '12px', fontWeight: 500, marginLeft: '8px' }}>
                                {isPrivate ? '****' : formatCurrency(entry.value)}
                            </Text>
                        </div>
                    ))}
                </div>
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                    <Text style={{ fontSize: '13px', fontWeight: 'bold' }}>Total</Text>
                    <Text style={{ fontSize: '13px', fontWeight: 'bold' }}>
                        {isPrivate ? '****' : formatCurrency(total)}
                    </Text>
                </div>
            </div>
        </div>
    );
};

const ReceitasCategoriaChart = ({ data, loading, onSelect }) => {
    const { isPrivate } = usePrivacy();
    const COLORS = chartPalette;

    const chartData = useMemo(() => processPieData(data), [data]);
    const total = chartData.reduce((acc, entry) => acc + entry.value, 0);

    if (loading) return <div style={{ height: 350, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin /></div>;

    return (
        <div className="chart-container-responsive">
            <style>{`
                .chart-container-responsive {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: auto;
                    min-height: 400px;
                    }
                .chart-area {
                    width: 100%;
                    height: 250px;
                }
                .legend-area {
                    width: 100%;
                    padding-top: 16px;
                    display: flex;
                    flex-direction: column;
                    max-height: 200px;
                }
                @media (min-width: 992px) {
                    .chart-container-responsive {
                        flex-direction: row;
                        align-items: center;
                        height: 300px;
                        min-height: 300px;
                    }
                    .chart-area {
                        width: 55%;
                        height: 100%;
                    }
                    .legend-area {
                        width: 45%;
                        padding-left: 16px;
                        padding-top: 0;
                        height: 100%;
                        max-height: 100%;
                    }
                }
            `}</style>

            {chartData.length === 0 && <EmptyChartState message="Sem receitas para exibir." />}

            <div className="chart-area" style={{ opacity: chartData.length === 0 ? 0.3 : 1 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Tooltip content={<CustomPieTooltip />} />
                        <Pie
                            data={chartData} cx="50%" cy="50%" labelLine={false} label={false}
                            outerRadius={80} innerRadius={40} dataKey="value" nameKey="name"
                            paddingAngle={1} stroke="#FFFFFF" strokeWidth={2} minAngle={6}
                            onClick={(_, index) => onSelect?.(chartData[index])}
                            style={onSelect ? { cursor: 'pointer' } : undefined}
                        >
                            {chartData.map((entry, index) => (<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>

            <div className="legend-area">
                <div style={{ flex: 1, overflowY: 'auto' }}>
                    {chartData.map((entry, index) => (
                        <div
                            key={index}
                            className={onSelect && entry.categoria_ids?.length ? 'desempenho-categoria-linha is-clicavel' : 'desempenho-categoria-linha'}
                            onClick={() => onSelect?.(entry)}
                        >
                            <div style={{ width: '10px', height: '10px', backgroundColor: COLORS[index % COLORS.length], marginRight: '8px', borderRadius: '50%', flexShrink: 0 }}></div>
                            <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                <Text style={{ fontSize: '12px' }} title={entry.name}>{entry.name}</Text>
                            </div>
                            <Text style={{ fontSize: '12px', fontWeight: 500, marginLeft: '8px' }}>
                                {isPrivate ? '****' : formatCurrency(entry.value)}
                            </Text>
                        </div>
                    ))}
                </div>
                <Divider style={{ margin: '8px 0' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                    <Text style={{ fontSize: '13px', fontWeight: 'bold' }}>Total</Text>
                    <Text style={{ fontSize: '13px', fontWeight: 'bold' }}>
                        {isPrivate ? '****' : formatCurrency(total)}
                    </Text>
                </div>
            </div>
        </div>
    );
};

const ReceitasDespesasChart = ({ data, loading, onSelect }) => {
    const { isPrivate } = usePrivacy();
    if (loading) return <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin /></div>;

    return (
        <div style={{ position: 'relative' }}>
            {data.length === 0 && <EmptyChartState message="Sem dados históricos para exibir." />}
            <ResponsiveContainer width="100%" height={300} style={{ opacity: data.length === 0 ? 0.3 : 1 }}>
                <BarChart data={data} margin={{ top: 20, right: 10, left: 0, bottom: 5 }}>
                    <CartesianGrid stroke="#f0f0f0" vertical={false} />
                    <XAxis dataKey="mes_ano" axisLine={false} tickLine={false} tick={{ fontSize: 12 }} />
                    <YAxis tickFormatter={(val) => isPrivate ? '****' : `R$ ${val / 1000}k`} axisLine={false} tickLine={false} width={60} tick={{ fontSize: 12 }} />
                    <Tooltip content={<CustomChartTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Bar
                        dataKey="receitas" fill="#2e7d32" name="Receitas" radius={[4, 4, 0, 0]} barSize={30}
                        onClick={(_, index) => onSelect?.(index, 'receita')}
                        style={onSelect ? { cursor: 'pointer' } : undefined}
                    />
                    <Bar
                        dataKey="despesas" fill="#c62828" name="Despesas" radius={[4, 4, 0, 0]} barSize={30}
                        onClick={(_, index) => onSelect?.(index, 'despesa')}
                        style={onSelect ? { cursor: 'pointer' } : undefined}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

const EvolucaoPatrimonioChart = ({ data, loading }) => {
    const { isPrivate } = usePrivacy();
    const BRAND_COLOR = '#50B0A0';
    if (loading) return <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin /></div>;

    return (
        <div style={{ position: 'relative' }}>
            {data.length === 0 && <EmptyChartState message="Sem dados históricos para exibir." />}
            <ResponsiveContainer width="100%" height={300} style={{ opacity: data.length === 0 ? 0.3 : 1 }}>
                <LineChart data={data} margin={{ top: 20, right: 10, left: 0, bottom: 5 }}>
                    <defs>
                        <linearGradient id="colorPatrimonio" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={BRAND_COLOR} stopOpacity={0.8} />
                            <stop offset="95%" stopColor={BRAND_COLOR} stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid stroke="#f0f0f0" vertical={false} />
                    <XAxis dataKey="mes_ano" axisLine={false} tickLine={false} tick={{ fontSize: 12 }} />
                    <YAxis tickFormatter={(val) => isPrivate ? '****' : `R$ ${val / 1000}k`} axisLine={false} tickLine={false} width={60} tick={{ fontSize: 12 }} />
                    <Tooltip content={<CustomChartTooltip />} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Line type="monotone" dataKey="saldo_consolidado" stroke={BRAND_COLOR} name="Patrimônio" strokeWidth={3} dot={{ r: 4 }} activeDot={{ r: 6 }} />
                    <Area type="monotone" dataKey="saldo_consolidado" stroke={false} fill="url(#colorPatrimonio)" legendType="none" />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

const ProjecaoGastosChart = ({ data, loading }) => {
    const { isPrivate } = usePrivacy();
    if (loading) return <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin /></div>;

    return (
        <div style={{ position: 'relative' }}>
            {data.length === 0 && <EmptyChartState message="Sem gastos futuros para projetar." />}
            <ResponsiveContainer width="100%" height={300} style={{ opacity: data.length === 0 ? 0.3 : 1 }}>
                <BarChart data={data} margin={{ top: 20, right: 10, left: 0, bottom: 5 }}>
                    <CartesianGrid stroke="#f0f0f0" vertical={false} />
                    <XAxis dataKey="mes_ano" axisLine={false} tickLine={false} interval={0} tick={{ fontSize: 11 }} />
                    <YAxis tickFormatter={(val) => isPrivate ? '****' : `R$ ${val / 1000}k`} axisLine={false} tickLine={false} width={60} tick={{ fontSize: 12 }} />
                    <Tooltip content={<CustomChartTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Bar dataKey="recorrencias_conta" stackId="a" fill="#1F4F4F" name="Recorrências (Conta)" />
                    <Bar dataKey="recorrencias_cartao" stackId="a" fill="#ffc658" name="Recorrências (Cartão)" />
                    <Bar dataKey="parcelas" stackId="a" fill="#82ca9d" name="Parcelas" radius={[4, 4, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

const MediaGastosCategoriaTooltip = ({ active, payload, label }) => {
    const { isPrivate } = usePrivacy();

    if (!active || !payload || payload.length === 0) return null;

    const item = payload[0]?.payload || {};
    const variacao = item.variacao_pct;
    let variacaoLabel = 'Sem média para comparar';
    let variacaoColor = 'var(--color-text-secondary, #5A6A6A)';
    if (variacao != null) {
        if (variacao > 0) {
            variacaoLabel = `Acima da média (+${variacao.toFixed(1)}%)`;
            variacaoColor = '#D64545';
        } else if (variacao < 0) {
            variacaoLabel = `Abaixo da média (${variacao.toFixed(1)}%)`;
            variacaoColor = '#2F9E6F';
        } else {
            variacaoLabel = 'Na média';
            variacaoColor = 'var(--color-text-secondary, #5A6A6A)';
        }
    }

    const containerStyle = {
        backgroundColor: 'rgba(33, 33, 33, 0.9)', border: 'none',
        borderRadius: '4px', padding: '8px 12px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
    };
    const textStyle = { color: '#FFFFFF', margin: 0, fontSize: '12px' };

    return (
        <div style={containerStyle}>
            <p style={{ ...textStyle, fontWeight: 'bold', paddingBottom: '4px' }}>{label}</p>
            {payload.map((pld, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ width: '10px', height: '10px', backgroundColor: pld.color || pld.fill, marginRight: '8px' }}></div>
                    <p style={textStyle}>{`${pld.name}: ${isPrivate ? '****' : formatCurrency(pld.value)}`}</p>
                </div>
            ))}
            <p style={{ ...textStyle, color: variacaoColor, paddingTop: '4px' }}>{variacaoLabel}</p>
        </div>
    );
};

const MediaGastosCategoriaChart = ({ data, loading }) => {
    const { isPrivate } = usePrivacy();
    const chartData = useMemo(() => (Array.isArray(data) ? data : []), [data]);
    const chartHeight = Math.max(280, chartData.length * 36 + 80);

    if (loading) {
        return (
            <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin />
            </div>
        );
    }

    return (
        <div style={{ position: 'relative' }}>
            {chartData.length === 0 && <EmptyChartState message="Sem histórico de despesas por categoria." />}
            <ResponsiveContainer
                width="100%"
                height={chartHeight}
                style={{ opacity: chartData.length === 0 ? 0.3 : 1 }}
            >
                <BarChart
                    layout="vertical"
                    data={chartData}
                    margin={{ top: 8, right: 24, left: 8, bottom: 8 }}
                >
                    <CartesianGrid stroke="#f0f0f0" horizontal={false} />
                    <XAxis
                        type="number"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 12 }}
                        tickFormatter={(val) => (isPrivate ? '****' : `R$ ${val / 1000}k`)}
                    />
                    <YAxis
                        type="category"
                        dataKey="name"
                        width={110}
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 12 }}
                    />
                    <Tooltip content={<MediaGastosCategoriaTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Bar dataKey="media" fill="#50B0A0" name="Média (6 meses)" radius={[0, 4, 4, 0]} barSize={12} />
                    <Bar dataKey="mes_atual" fill="#c62828" name="Mês atual" radius={[0, 4, 4, 0]} barSize={12} />
                </BarChart>
            </ResponsiveContainer>

            {chartData.length > 0 && (
                <div className="media-gastos-categoria-lista" style={{ marginTop: 12, maxHeight: 180, overflowY: 'auto' }}>
                    {chartData.map((entry) => {
                        const variacao = entry.variacao_pct;
                        let tagColor = 'default';
                        let tagText = 'Sem média';
                        if (variacao != null) {
                            if (variacao > 0) {
                                tagColor = 'error';
                                tagText = `Acima da média (+${variacao.toFixed(1)}%)`;
                            } else if (variacao < 0) {
                                tagColor = 'success';
                                tagText = `Abaixo da média (${variacao.toFixed(1)}%)`;
                            } else {
                                tagText = 'Na média';
                            }
                        }
                        return (
                            <div
                                key={entry.name}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 8,
                                    marginBottom: 8,
                                }}
                            >
                                <Text style={{ fontSize: 12, flex: 1 }} ellipsis={{ tooltip: entry.name }}>
                                    {entry.name}
                                </Text>
                                <Tag color={tagColor} style={{ margin: 0, fontSize: 11 }}>
                                    {tagText}
                                </Tag>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

const GastoPortadorChart = ({ dados, loading }) => {
    const { isPrivate } = usePrivacy();

    const chartData = useMemo(() => {
        if (!dados) return [];
        const linhas = (dados.portadores || []).map((p) => ({
            nome: p.portador,
            total: p.total,
            media_3m: p.media_3m ?? null,
        }));
        if (dados.titular && dados.titular.total > 0) {
            linhas.push({ nome: 'Titular', total: dados.titular.total, media_3m: dados.titular.media_3m ?? null });
        }
        return linhas.sort((a, b) => b.total - a.total);
    }, [dados]);

    const chartHeight = Math.max(220, chartData.length * 40 + 60);

    if (loading) {
        return (
            <div style={{ height: 260, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin />
            </div>
        );
    }

    return (
        <div style={{ position: 'relative' }}>
            {chartData.length === 0 && <EmptyChartState message="Sem gastos por portador neste mês." />}
            <ResponsiveContainer
                width="100%"
                height={chartHeight}
                style={{ opacity: chartData.length === 0 ? 0.3 : 1 }}
            >
                <BarChart layout="vertical" data={chartData} margin={{ top: 8, right: 24, left: 8, bottom: 8 }}>
                    <CartesianGrid stroke="#f0f0f0" horizontal={false} />
                    <XAxis
                        type="number"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 12 }}
                        tickFormatter={(val) => (isPrivate ? '****' : `R$ ${val / 1000}k`)}
                    />
                    <YAxis type="category" dataKey="nome" width={110} axisLine={false} tickLine={false} tick={{ fontSize: 12 }} />
                    <Tooltip content={<CustomChartTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />
                    <Legend wrapperStyle={{ paddingTop: '10px' }} />
                    <Bar dataKey="media_3m" fill="#B7C4C4" name="Média (3 meses)" radius={[0, 4, 4, 0]} barSize={10} />
                    <Bar dataKey="total" fill={chartPalette[0]} name="Este mês" radius={[0, 4, 4, 0]} barSize={14} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

// --- NOVO: Componente "Radar de Recebíveis" ULTRA COMPACTO (responsivo) ---
const ResumoRecebiveisMilhas = ({ dados, loading, isPrivate, isMobile }) => {
    if (loading || !dados) return <Spin />;

    const hasData = dados.atrasados.qtd > 0 || dados.proximos_7_dias.qtd > 0 || dados.futuros.qtd > 0;
    if (!hasData) return null;

    const itemStyle = (opacity) => ({ display: 'flex', alignItems: 'center', opacity: opacity === 0 ? 0.4 : 1 });

    return (
        <div style={{
            background: '#ffffff',
            padding: '16px',
            borderRadius: '8px',
            border: '1px solid #f0f0f0',
            marginBottom: 24,
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
        }}>
            <Row align="middle" gutter={[16, isMobile ? 12 : 8]}>
                <Col xs={24} md={6}>
                    <Text strong style={{ fontSize: '14px' }}>
                        <CalendarOutlined style={{ marginRight: 8 }} />
                        Fluxo de Recebimento
                    </Text>
                </Col>
                <Col xs={24} md={18}>
                    <Row gutter={isMobile ? [0, 12] : 24} style={isMobile ? { flexDirection: 'column', alignItems: 'flex-start' } : {}}>
                        <Col style={itemStyle(dados.atrasados.qtd)}>
                            <WarningOutlined style={{ color: '#D64545', fontSize: '16px', marginRight: 8 }} />
                            <div>
                                <div style={{ fontSize: '12px', color: 'var(--color-text-secondary, #5A6A6A)' }}>Atrasados</div>
                                <div style={{ fontWeight: 'bold', color: '#D64545' }}>
                                    {isPrivate ? '****' : formatNumber(dados.atrasados.total) + ' pts'}
                                </div>
                            </div>
                        </Col>
                        {!isMobile && <Divider type="vertical" style={{ height: '32px', top: '0' }} />}
                        <Col style={itemStyle(dados.proximos_7_dias.qtd)}>
                            <ClockCircleOutlined style={{ color: '#50B0A0', fontSize: '16px', marginRight: 8 }} />
                            <div>
                                <div style={{ fontSize: '12px', color: 'var(--color-text-secondary, #5A6A6A)' }}>Próximos 7 dias</div>
                                <div style={{ fontWeight: 'bold', color: '#50B0A0' }}>
                                    {isPrivate ? '****' : formatNumber(dados.proximos_7_dias.total) + ' pts'}
                                </div>
                            </div>
                        </Col>
                        {!isMobile && <Divider type="vertical" style={{ height: '32px', top: '0' }} />}
                        <Col style={itemStyle(dados.futuros.qtd)}>
                            <CheckCircleOutlined style={{ color: '#2F9E6F', fontSize: '16px', marginRight: 8 }} />
                            <div>
                                <div style={{ fontSize: '12px', color: 'var(--color-text-secondary, #5A6A6A)' }}>Futuro (+7d)</div>
                                <div style={{ fontWeight: 'bold', color: '#2F9E6F' }}>
                                    {isPrivate ? '****' : formatNumber(dados.futuros.total) + ' pts'}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

// --- COMPONENTE PRINCIPAL ---

function resolveInitialTab(temFin, temMil, tabParam) {
    const t = tabParam === 'Milhas' || tabParam === 'Financeiro' ? tabParam : null;
    if (t === 'Milhas' && temMil) return 'Milhas';
    if (t === 'Financeiro' && temFin) return 'Financeiro';
    if (temFin) return 'Financeiro';
    if (temMil) return 'Milhas';
    return 'Financeiro';
}

function MeuDesempenhoPage() {
    const { refreshKey } = useDataRefresh();
    const { isPrivate } = usePrivacy();
    const { temModuloFinanceiro, temModuloMilhas, temModoPrestador } = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    // Estados Financeiros
    const [dashboardData, setDashboardData] = useState(null);
    const [proximasFaturas, setProximasFaturas] = useState([]);
    const [loading, setLoading] = useState(() => temModuloFinanceiro);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [regime, setRegime] = useState(loadRegimePreferidoDesempenho);
    const [modalFaturamentoOpen, setModalFaturamentoOpen] = useState(false);
    const [savingFaturamento, setSavingFaturamento] = useState(false);
    const [formFaturamento] = Form.useForm();
    const [preferenciasUi, setPreferenciasUi] = useState({});
    const [personalizarOpen, setPersonalizarOpen] = useState(false);
    const [draftCards, setDraftCards] = useState({});
    const [savingPersonalizar, setSavingPersonalizar] = useState(false);
    const [insightsDismissBusy, setInsightsDismissBusy] = useState(false);
    const [cartoesLista, setCartoesLista] = useState([]);
    const [adicionaisLista, setAdicionaisLista] = useState([]);
    const [filtrosOpen, setFiltrosOpen] = useState(false);
    const [savingFiltros, setSavingFiltros] = useState(false);
    // Incrementa ao salvar filtros: o backend lê a preferência, só precisamos recarregar
    const [filtrosVersao, setFiltrosVersao] = useState(0);

    // Estados de Milhas

    const [desempenhoMilhas, setDesempenhoMilhas] = useState([]);
    const [recebiveisMilhas, setRecebiveisMilhas] = useState(null);
    const [loadingMilhas, setLoadingMilhas] = useState(() => temModuloMilhas);
    const [portadores, setPortadores] = useState([]);
    const [selectedPortadorId, setSelectedPortadorId] = useState('todos');
    const [cpfDataByPrograma, setCpfDataByPrograma] = useState({});
    
    const [activeTab, setActiveTab] = useState(() =>
        resolveInitialTab(
            temModuloFinanceiro,
            temModuloMilhas,
            searchParams.get('tab'),
        ),
    );

    const pageTitle = useMemo(() => {
        if (temModuloFinanceiro && temModuloMilhas) return 'Meu Desempenho';
        if (temModuloMilhas && !temModuloFinanceiro) return 'Meu Desempenho — Milhas';
        return 'Meu Desempenho';
    }, [temModuloFinanceiro, temModuloMilhas]);

    useEffect(() => {
        const tabParam = searchParams.get('tab');
        const next = resolveInitialTab(temModuloFinanceiro, temModuloMilhas, tabParam);
        setActiveTab(next);
    }, [searchParams, temModuloFinanceiro, temModuloMilhas]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (temModuloFinanceiro && temModuloMilhas) {
            setSearchParams({ tab: key }, { replace: true });
        }
    };
    
    // Responsividade
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const perfil = await getPerfil();
                if (!cancelled) {
                    setPreferenciasUi(
                        perfil?.preferencias_ui && typeof perfil.preferencias_ui === 'object'
                            ? perfil.preferencias_ui
                            : {},
                    );
                }
            } catch (err) {
                console.error('Falha ao carregar preferências de UI:', err);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const cardVisivel = useCallback(
        (cardId) => isCardVisible(preferenciasUi, cardId),
        [preferenciasUi],
    );

    const insightsDismissedMap = useMemo(
        () => getInsightsDismissedMap(preferenciasUi),
        [preferenciasUi],
    );

    const persistInsightsDismissed = useCallback(async (nextMap) => {
        setInsightsDismissBusy(true);
        const previous = preferenciasUi;
        const patch = buildInsightsDismissedPatch(preferenciasUi, nextMap);
        setPreferenciasUi(patch);
        try {
            const updated = await updatePerfil({ preferencias_ui: patch });
            setPreferenciasUi(
                updated?.preferencias_ui && typeof updated.preferencias_ui === 'object'
                    ? updated.preferencias_ui
                    : patch,
            );
        } catch (err) {
            setPreferenciasUi(previous);
            message.error(getErrorMessage(err, 'Não foi possível atualizar os insights.'));
        } finally {
            setInsightsDismissBusy(false);
        }
    }, [preferenciasUi]);

    const handleDismissInsight = useCallback((insightId) => {
        const next = dismissInsightInMap(insightsDismissedMap, insightId);
        void persistInsightsDismissed(next);
    }, [insightsDismissedMap, persistInsightsDismissed]);

    const handleRestoreHiddenInsights = useCallback((insightIds) => {
        const next = restoreInsightIdsInMap(insightsDismissedMap, insightIds);
        void persistInsightsDismissed(next);
    }, [insightsDismissedMap, persistInsightsDismissed]);

    const openPersonalizar = () => {
        setDraftCards(getDesempenhoCardsMap(preferenciasUi));
        setPersonalizarOpen(true);
    };

    const toggleDraftCard = (cardId, checked) => {
        setDraftCards((prev) => {
            const next = { ...prev };
            if (checked) {
                delete next[cardId];
            } else {
                next[cardId] = false;
            }
            return next;
        });
    };

    const salvarPersonalizar = async () => {
        setSavingPersonalizar(true);
        try {
            const patch = buildPreferenciasUiPatch(preferenciasUi, draftCards);
            const updated = await updatePerfil({ preferencias_ui: patch });
            setPreferenciasUi(
                updated?.preferencias_ui && typeof updated.preferencias_ui === 'object'
                    ? updated.preferencias_ui
                    : patch,
            );
            setPersonalizarOpen(false);
            message.success('Preferências salvas.');
        } catch (err) {
            message.error(getErrorMessage(err, 'Não foi possível salvar as preferências.'));
        } finally {
            setSavingPersonalizar(false);
        }
    };

    const restaurarPadraoPersonalizar = async () => {
        setSavingPersonalizar(true);
        try {
            const patch = buildPreferenciasUiPatch(preferenciasUi, null);
            const updated = await updatePerfil({ preferencias_ui: patch });
            setPreferenciasUi(
                updated?.preferencias_ui && typeof updated.preferencias_ui === 'object'
                    ? updated.preferencias_ui
                    : patch,
            );
            setDraftCards({});
            setPersonalizarOpen(false);
            message.success('Padrão restaurado: todos os cards visíveis.');
        } catch (err) {
            message.error(getErrorMessage(err, 'Não foi possível restaurar o padrão.'));
        } finally {
            setSavingPersonalizar(false);
        }
    };

    const filtrosDesempenho = useMemo(() => getDesempenhoFiltros(preferenciasUi), [preferenciasUi]);
    const qtdFiltrosAtivos = contarFiltrosAtivos(filtrosDesempenho);

    const openFiltros = async () => {
        setFiltrosOpen(true);
        try {
            setAdicionaisLista(await getTodosCartoesAdicionais());
        } catch (err) {
            message.error(getErrorMessage(err, 'Não foi possível carregar os cartões adicionais.'));
        }
    };

    const salvarFiltros = async (filtros) => {
        setSavingFiltros(true);
        try {
            const patch = buildFiltrosPatch(preferenciasUi, filtros);
            const updated = await updatePerfil({ preferencias_ui: patch });
            setPreferenciasUi(
                updated?.preferencias_ui && typeof updated.preferencias_ui === 'object'
                    ? updated.preferencias_ui
                    : patch,
            );
            setFiltrosOpen(false);
            setFiltrosVersao((v) => v + 1);
        } catch (err) {
            message.error(getErrorMessage(err, 'Não foi possível salvar os filtros.'));
        } finally {
            setSavingFiltros(false);
        }
    };

    // Carregamento de dados financeiros
    const carregarDadosFinanceiros = useCallback(async () => {
        if (!temModuloFinanceiro) return;
        setLoading(true);
        setDashboardData(null);

        try {
            const promises = [getContas(), getCartoes(), getProximasFaturas().catch(() => [])];
            if (temModuloMilhas) {
                promises.push(getPortadores());
            }
            const results = await Promise.all(promises);
            const contas = results[0];
            const cartoes = results[1];
            setCartoesLista(cartoes);
            const faturas = Array.isArray(results[2]) ? results[2] : (results[2]?.results || []);
            setProximasFaturas(faturas);

            if (temModuloMilhas && results[3]) {
                setPortadores(results[3].data);
            }

            const contasIds = contas.map(c => c.id);
            const cartoesIds = cartoes.map(c => c.id);
            const ano = selectedDate.year();
            const mes = selectedDate.month() + 1;

            const data = await getFullDashboardData(ano, mes, contasIds, cartoesIds, false, regime);
            setDashboardData(data);
        } catch (err) {
            console.error("Erro ao carregar dados financeiros:", err);
            message.error(getErrorMessage(err, "Erro ao carregar dados financeiros."));
            setDashboardData(null);
            setProximasFaturas([]);
            setPortadores([]);
        } finally {
            setLoading(false);
        }
    }, [selectedDate, regime, temModuloFinanceiro, temModuloMilhas]);

    const handleRegimeChange = (value) => {
        setRegime(value);
        try {
            localStorage.setItem(REGIME_STORAGE_KEY, value);
        } catch (_) {
            /* ignore */
        }
    };

    // Carregamento de dados de milhas
    const carregarDadosMilhas = useCallback(async (portadorId) => {
        if (!temModuloMilhas) return;
        setLoadingMilhas(true);
        try {
            const id = portadorId === 'todos' ? null : portadorId;

            const extra = [];
            if (!temModuloFinanceiro) {
                extra.push(getPortadores());
            }
            const [resDesempenho, resRecebiveis, resCpf, portadoresRes] = await Promise.all([
                getDesempenhoMilhas(id),
                getMilhasRecebiveis(id),
                getControleCpfs(),
                ...extra,
            ]);
            if (portadoresRes?.data) {
                setPortadores(portadoresRes.data);
            }

            setDesempenhoMilhas(resDesempenho.data);
            setRecebiveisMilhas(resRecebiveis.data);
            const cpfList = resCpf?.data ?? [];
            const mapa = {};
            cpfList.forEach(item => { mapa[item.programa_portador_id] = item; });
            setCpfDataByPrograma(mapa);
        } catch (err) {
            console.error("Erro ao carregar dados de desempenho de milhas:", err);
            message.error(getErrorMessage(err, "Erro ao carregar dados de milhas."));
            setDesempenhoMilhas([]);
            setRecebiveisMilhas(null);
            setCpfDataByPrograma({});
        } finally {
            setLoadingMilhas(false);
        }
    }, [temModuloMilhas, temModuloFinanceiro]);

    // Efeito principal: carrega dados financeiros ao mudar data OU refreshKey
    useEffect(() => {
        if (temModuloFinanceiro) {
            carregarDadosFinanceiros();
        } else {
            setLoading(false);
            setDashboardData(null);
            setProximasFaturas([]);
        }
    }, [carregarDadosFinanceiros, refreshKey, temModuloFinanceiro, filtrosVersao]);

    // Efeito secundário: carrega milhas ao mudar portador OU refreshKey
    useEffect(() => {
        if (temModuloMilhas) {
            carregarDadosMilhas(selectedPortadorId);
        } else {
            setLoadingMilhas(false);
            setDesempenhoMilhas([]);
        }
    }, [selectedPortadorId, carregarDadosMilhas, refreshKey, temModuloMilhas]);

    const handleMonthChange = (newDate) => {
        if (newDate) {
            setSelectedDate(dayjs(newDate));
        }
    };

    // --- CÁLCULO INTELIGENTE DO SALDO PREVISTO (NOVA LÓGICA) ---
    const saldoPrevistoSincronizado = useMemo(() => {
        if (!dashboardData?.evolucao_patrimonio) return dashboardData?.saldo_previsto_em_contas;

        const mesAnoSelecionado = selectedDate.format('MMM/YY').replace('.', '').toUpperCase();

        const pontoDoGrafico = dashboardData.evolucao_patrimonio.find(p =>
            p.mes_ano.replace('.', '').toUpperCase() === mesAnoSelecionado
        );

        return pontoDoGrafico ? pontoDoGrafico.saldo_consolidado : dashboardData.saldo_previsto_em_contas;

    }, [dashboardData, selectedDate]);

    // --- CÁLCULO DO BALANÇO DO MÊS (Substitui Taxa de Economia %) ---
    const balancoMensal = useMemo(() => {
        if (!dashboardData) return 0;
        const receitas = parseFloat(dashboardData.total_receitas_mes) || 0;
        const despesas = parseFloat(dashboardData.total_despesas_mes) || 0;
        return receitas - despesas;
    }, [dashboardData]);

    // 1 fatura por cartão (API já ordenada por data_vencimento)
    const proximaFaturaPorCartao = useMemo(() => {
        const seen = new Set();
        const result = [];
        const ocultos = new Set(filtrosDesempenho.cartoes_ocultos);
        for (const f of proximasFaturas) {
            if (ocultos.has(f.cartao_id)) continue;
            const key = String(f.cartao_id ?? f.cartao_nome ?? f.id);
            if (seen.has(key)) continue;
            seen.add(key);
            result.push(f);
        }
        return result;
    }, [proximasFaturas, filtrosDesempenho]);

    // --- ORDENAÇÃO DE PROGRAMAS PARA AGREGAR PORTADORES ---
    const programasOrdenados = useMemo(() => {
        if (!desempenhoMilhas) return [];
        return [...desempenhoMilhas].sort((a, b) => {
            // Ordena primeiro por Nome do Programa
            const prog = a.programa_nome.localeCompare(b.programa_nome);
            if (prog !== 0) return prog;
            // Se for o mesmo programa, ordena por Nome do Portador
            return a.portador_nome.localeCompare(b.portador_nome);
        });
    }, [desempenhoMilhas]);

    /**
     * Abre Relatórios com o mesmo recorte do gráfico: mês, regime e os
     * portadores/cartões ocultos aqui (filtros_desempenho=1).
     */
    const abrirRelatorio = ({ mes, tipo, categoriaIds }) => {
        const params = new URLSearchParams({
            inicio: mes.startOf('month').format('YYYY-MM-DD'),
            fim: mes.endOf('month').format('YYYY-MM-DD'),
            regime,
            tipo,
            filtros_desempenho: '1',
            origem: 'desempenho',
        });
        if (categoriaIds?.length) params.set('categorias', categoriaIds.join(','));
        navigate(`/relatorios?${params.toString()}`);
    };

    const abrirCategoria = (tipo) => (entry) => {
        // "Sem Categoria" não tem id para filtrar
        if (!entry?.categoria_ids?.length) return;
        abrirRelatorio({ mes: selectedDate, tipo, categoriaIds: entry.categoria_ids });
    };

    // receitas_vs_despesas = [-2, -1, mês, +1, +2, +3]
    const abrirMesDoGrafico = (index, tipo) => {
        abrirRelatorio({ mes: selectedDate.add(index - 2, 'month'), tipo });
    };

    const handleFaturaClick = (fatura) => {
        if (!fatura?.cartao_id) return;
        const { cartao_id: cartaoId, ano_referencia: ano, mes_referencia: mes } = fatura;
        if (ano != null && mes != null) {
            navigate(`/cartoes/${cartaoId}?ano=${ano}&mes=${mes}`);
        } else {
            navigate(`/cartoes/${cartaoId}`);
        }
    };

    const formatDateBr = (dateStr) => {
        if (!dateStr) return '';
        return dayjs(dateStr).format('DD/MM/YYYY');
    };

    const renderFinanceiroToolbar = () => {
        const nomesOcultos = [
            ...filtrosDesempenho.portadores_ocultos,
            ...filtrosDesempenho.cartoes_ocultos.map(
                (id) => cartoesLista.find((c) => c.id === id)?.nome || 'Cartão',
            ),
        ];
        return (
            <>
                <div style={{
                    marginBottom: qtdFiltrosAtivos ? 12 : 24,
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: isMobile ? 'center' : 'space-between',
                    alignItems: isMobile ? 'stretch' : 'flex-end',
                    gap: 12,
                }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <Space wrap align="center" style={{ marginBottom: 4 }}>
                            <Text strong>Como contar os gastos</Text>
                            <AntdTooltip title={REGIME_HELP[regime]}>
                                <InfoCircleOutlined style={{ color: 'var(--color-text-secondary, #5A6A6A)' }} />
                            </AntdTooltip>
                        </Space>
                        <Segmented
                            block={isMobile}
                            value={regime}
                            options={REGIME_OPTIONS}
                            onChange={handleRegimeChange}
                        />
                        <div>
                            <Text type="secondary" style={{ fontSize: 12 }}>{REGIME_HELP[regime]}</Text>
                        </div>
                    </div>
                    <Space align="center" style={isMobile ? { justifyContent: 'space-between' } : undefined}>
                        <Badge count={qtdFiltrosAtivos} size="small" color="#50B0A0">
                            <Button icon={<FilterOutlined />} onClick={openFiltros}>
                                Filtros
                            </Button>
                        </Badge>
                        <SeletorDeMes
                            value={selectedDate.toDate()}
                            onChange={handleMonthChange}
                        />
                    </Space>
                </div>
                {qtdFiltrosAtivos > 0 && (
                    <div className="desempenho-filtro-ativo">
                        <FilterOutlined />
                        <span>
                            Fora dos indicadores: <strong>{nomesOcultos.join(', ')}</strong>
                        </span>
                        <Button type="link" size="small" onClick={openFiltros} style={{ padding: 0 }}>
                            Alterar
                        </Button>
                    </div>
                )}
            </>
        );
    };

    const renderFinanceiroContent = () => {
        if (loading) {
            return (
                <div className="brand-skeleton" aria-busy="true" aria-label="Carregando desempenho">
                    <div className="brand-skeleton-line brand-skeleton-line--lg" />
                    <div className="brand-skeleton-line brand-skeleton-line--md" />
                    <div className="brand-skeleton-line" />
                    <div className="brand-skeleton-line brand-skeleton-line--sm" />
                </div>
            );
        }
        if (!dashboardData) {
            return <div style={{ textAlign: 'center', padding: '50px' }}>Não foi possível carregar os dados.</div>;
        }

        return (
            <>
                {cardVisivel('insights_financeiros') && (
                    <InsightsFinanceirosCard
                        insights={dashboardData.insights}
                        isPrivate={isPrivate}
                        dismissedMap={insightsDismissedMap}
                        onDismiss={handleDismissInsight}
                        onRestoreHidden={handleRestoreHiddenInsights}
                        busy={insightsDismissBusy}
                    />
                )}
                {(() => {
                    const saldoAtual = dashboardData.saldo_atual_em_contas;
                    // receitas_vs_despesas = [-2, -1, mês, +1, +2, +3] com o mesmo regime/filtros
                    const mesAnterior = (dashboardData.receitas_vs_despesas || [])[1] || {};
                    const mesAnteriorLabel = selectedDate.subtract(1, 'month').format('MMM').replace('.', '');
                    const hero = cardVisivel('saldo_atual') && (
                        <Col xs={24} key="saldo_atual_hero">
                            <Card className="desempenho-hero-card" bordered={false}>
                                <div className="desempenho-hero-label">
                                    <WalletOutlined />
                                    <TitleWithHelp help="Soma do saldo atual de todas as suas contas ativas.">
                                        Saldo atual em contas
                                    </TitleWithHelp>
                                </div>
                                <div
                                    className={`desempenho-hero-value${Number(saldoAtual) < 0 ? ' is-negative' : ''}`}
                                >
                                    {isPrivate ? '****' : formatCurrency(saldoAtual)}
                                </div>
                            </Card>
                        </Col>
                    );
                    const kpis = [
                        cardVisivel('total_receitas') && (
                            <Col xs={24} sm={8} key="total_receitas">
                                <Card className="desempenho-kpi-card" bordered={false}>
                                    <Statistic
                                        title={<TitleWithHelp help="Soma de todas as receitas pagas, pendentes e recorrentes projetadas para o período selecionado.">Total de Receitas</TitleWithHelp>}
                                        value={isPrivate ? '****' : dashboardData.total_receitas_mes}
                                        formatter={isPrivate ? undefined : formatCurrency}
                                        prefix={<ArrowUpOutlined />}
                                        valueStyle={{ color: '#2F9E6F', fontVariantNumeric: 'tabular-nums' }}
                                    />
                                    <VariacaoMes
                                        atual={dashboardData.total_receitas_mes}
                                        anterior={mesAnterior.receitas}
                                        maiorEhBom
                                        mesAnteriorLabel={mesAnteriorLabel}
                                        isPrivate={isPrivate}
                                    />
                                </Card>
                            </Col>
                        ),
                        cardVisivel('total_despesas') && (
                            <Col xs={24} sm={8} key="total_despesas">
                                <Card className="desempenho-kpi-card" bordered={false}>
                                    <Statistic
                                        title={<TitleWithHelp help={regime === REGIME_COMPETENCIA
                                            ? 'Soma de despesas do mês pela data da compra/lançamento (cartão incluso mesmo que a fatura vença depois), mais projeções.'
                                            : 'Soma de despesas pagas, pendentes, projeções e o valor total de faturas com vencimento no mês selecionado.'
                                        }>Total de Despesas</TitleWithHelp>}
                                        value={isPrivate ? '****' : dashboardData.total_despesas_mes}
                                        formatter={isPrivate ? undefined : formatCurrency}
                                        prefix={<ArrowDownOutlined />}
                                        valueStyle={{ color: '#D64545', fontVariantNumeric: 'tabular-nums' }}
                                    />
                                    <VariacaoMes
                                        atual={dashboardData.total_despesas_mes}
                                        anterior={mesAnterior.despesas}
                                        maiorEhBom={false}
                                        mesAnteriorLabel={mesAnteriorLabel}
                                        isPrivate={isPrivate}
                                    />
                                </Card>
                            </Col>
                        ),
                        cardVisivel('saldo_previsto') && (
                            <Col xs={24} sm={8} key="saldo_previsto">
                                <Card className="desempenho-kpi-card" bordered={false}>
                                    <Statistic
                                        title={<TitleWithHelp help="Saldo projetado considerando o acumulado histórico até o final do mês selecionado.">Saldo Previsto (Fim do Mês)</TitleWithHelp>}
                                        value={isPrivate ? '****' : saldoPrevistoSincronizado}
                                        formatter={isPrivate ? undefined : formatCurrency}
                                        prefix={<SafetyCertificateOutlined />}
                                        valueStyle={{ color: saldoPrevistoSincronizado < 0 ? '#D64545' : '#2F9E6F', fontVariantNumeric: 'tabular-nums' }}
                                    />
                                    <div style={{ marginTop: 8, fontSize: '13px', display: 'flex', alignItems: 'center', color: balancoMensal >= 0 ? '#2F9E6F' : '#D64545' }}>
                                        <span style={{ marginRight: 4 }}>
                                            {balancoMensal >= 0 ? 'Economia no mês:' : 'Déficit no mês:'}
                                        </span>
                                        <strong>{isPrivate ? '****' : (balancoMensal >= 0 ? '+' : '') + formatCurrency(balancoMensal)}</strong>
                                    </div>
                                </Card>
                            </Col>
                        ),
                    ].filter(Boolean);
                    if (!hero && kpis.length === 0) return null;
                    return (
                        <div className="desempenho-kpi-block">
                            {hero ? <Row gutter={[16, 16]} style={{ marginBottom: 12 }}>{hero}</Row> : null}
                            {kpis.length > 0 ? <Row gutter={[16, 16]} align="stretch" className="desempenho-kpi-row" style={{ marginBottom: 24 }}>{kpis}</Row> : null}
                        </div>
                    );
                })()}

                <div className="dashboard-main-content">
                    {(() => {
                        const showRD = cardVisivel('chart_receitas_despesas');
                        const showDespCat = cardVisivel('chart_despesas_categoria');
                        const showRecCat = cardVisivel('chart_receitas_categoria');
                        const showCat = showDespCat || showRecCat;
                        const showEvo = cardVisivel('chart_evolucao_patrimonio');
                        const showProj = cardVisivel('chart_projecao_gastos');
                        if (!showRD && !showCat && !showEvo && !showProj) return null;

                        const abasCategoria = [
                            showDespCat && {
                                key: 'despesas',
                                label: 'Despesas',
                                children: (
                                    <DespesasCategoriaChart
                                        data={dashboardData.despesas_por_categoria}
                                        loading={loading}
                                        onSelect={abrirCategoria('despesa')}
                                    />
                                ),
                            },
                            showRecCat && {
                                key: 'receitas',
                                label: 'Receitas',
                                children: (
                                    <ReceitasCategoriaChart
                                        data={dashboardData.receitas_por_categoria}
                                        loading={loading}
                                        onSelect={abrirCategoria('receita')}
                                    />
                                ),
                            },
                        ].filter(Boolean);

                        return (
                            <Row gutter={[24, 24]}>
                                {showRD && (
                                <Col xs={24} lg={showCat ? 16 : 24}>
                                    <Card style={{ height: '100%' }}>
                                        <Title level={5}>
                                            <TitleWithHelp help="Comparativo de receitas e despesas realizadas e previstas para o período. Clique numa barra para ver as transações do mês.">
                                                Receitas vs. Despesas
                                            </TitleWithHelp>
                                        </Title>
                                        <ReceitasDespesasChart
                                            data={dashboardData.receitas_vs_despesas}
                                            loading={loading}
                                            onSelect={abrirMesDoGrafico}
                                        />
                                    </Card>
                                </Col>
                                )}
                                {showCat && (
                                <Col xs={24} lg={showRD ? 8 : 24}>
                                    <Card style={{ height: '100%' }} className="desempenho-categorias-card">
                                        <Title level={5} style={{ marginBottom: 0 }}>
                                            <TitleWithHelp help="Distribuição das despesas e receitas (realizadas e previstas) do mês por categoria. Clique numa categoria para ver as transações.">
                                                Por categoria
                                            </TitleWithHelp>
                                        </Title>
                                        <Tabs size="small" items={abasCategoria} />
                                    </Card>
                                </Col>
                                )}
                                {showEvo && (
                                <Col xs={24} lg={showProj ? 12 : 24}>
                                    <Card style={{ height: '100%' }}>
                                        <Title level={5}>
                                            <TitleWithHelp help="Mostra a evolução do saldo total de suas contas ao longo do tempo.">
                                                Evolução do Patrimônio
                                            </TitleWithHelp>
                                        </Title>
                                        <EvolucaoPatrimonioChart data={dashboardData.evolucao_patrimonio} loading={loading} />
                                    </Card>
                                </Col>
                                )}
                                {showProj && (
                                <Col xs={24} lg={showEvo ? 12 : 24}>
                                    <Card style={{ height: '100%' }}>
                                        <Title level={5}>
                                            <TitleWithHelp help="Soma das parcelas e despesas recorrentes para os próximos 12 meses, a partir de hoje.">
                                                Projeção de Gastos Comprometidos
                                            </TitleWithHelp>
                                        </Title>
                                        <ProjecaoGastosChart data={dashboardData.projecao_gastos_comprometidos} loading={loading} />
                                    </Card>
                                </Col>
                                )}
                            </Row>
                        );
                    })()}

                    {cardVisivel('chart_gasto_medio') && (
                    <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
                        <Col span={24}>
                            <Card>
                                <Title level={5}>
                                    <TitleWithHelp help="Média mensal de despesas por categoria nos últimos 6 meses, comparada ao mês selecionado.">
                                        Gasto médio por categoria
                                    </TitleWithHelp>
                                </Title>
                                <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 13 }}>
                                    Média dos últimos 6 meses
                                </Text>
                                <MediaGastosCategoriaChart
                                    data={dashboardData.media_despesas_por_categoria}
                                    loading={loading}
                                />
                            </Card>
                        </Col>
                    </Row>
                    )}

                    {cardVisivel('chart_gasto_portador') && dashboardData.gastos_por_portador && (
                    <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
                        <Col span={24}>
                            <Card>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                                    <Title level={5} style={{ margin: 0 }}>
                                        <TitleWithHelp help="Gasto de cartão de crédito atribuído a cada portador (cartão adicional) no mês selecionado, comparado à média dos 3 meses anteriores.">
                                            Gastos por portador
                                        </TitleWithHelp>
                                    </Title>
                                    <Button
                                        type="link"
                                        size="small"
                                        style={{ padding: 0 }}
                                        onClick={() => navigate('/relatorios?aba=portadores')}
                                    >
                                        Ver relatório completo
                                    </Button>
                                </div>
                                <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 13 }}>
                                    Comparado à média dos últimos 3 meses
                                </Text>
                                <GastoPortadorChart
                                    dados={dashboardData.gastos_por_portador}
                                    loading={loading}
                                />
                            </Card>
                        </Col>
                    </Row>
                    )}
                </div>

                {cardVisivel('proximas_faturas') && (
                <Card
                    title={
                        <TitleWithHelp help="Próxima fatura de cada cartão, com vencimento e valor. Toque para abrir o detalhe do cartão.">
                            Próximas faturas
                        </TitleWithHelp>
                    }
                    style={{ marginTop: 24 }}
                >
                    {proximaFaturaPorCartao.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '16px' }}>
                            <Text type="secondary">Nenhuma fatura próxima.</Text>
                        </div>
                    ) : (
                        <List
                            itemLayout="horizontal"
                            dataSource={proximaFaturaPorCartao}
                            renderItem={(fatura) => (
                                <List.Item
                                    style={{
                                        padding: '12px 0',
                                        cursor: fatura.cartao_id ? 'pointer' : 'default',
                                    }}
                                    onClick={() => handleFaturaClick(fatura)}
                                >
                                    <List.Item.Meta
                                        avatar={
                                            <LogoManager
                                                slug={fatura.cartao_bandeira}
                                                type="bandeira"
                                                size={36}
                                            />
                                        }
                                        title={
                                            <Text strong>
                                                {fatura.cartao_nome || `Fatura #${fatura.id}`}
                                            </Text>
                                        }
                                        description={
                                            <Text type="secondary" style={{ fontSize: 12 }}>
                                                {fatura.data_vencimento
                                                    ? `Venc. ${formatDateBr(fatura.data_vencimento)}`
                                                    : ''}
                                                {fatura.status
                                                    ? `${fatura.data_vencimento ? ' · ' : ''}${fatura.status}`
                                                    : ''}
                                            </Text>
                                        }
                                    />
                                    <div style={{ textAlign: 'right' }}>
                                        <Text strong style={{ fontSize: 16 }}>
                                            {isPrivate
                                                ? '****'
                                                : formatCurrency(fatura.valor_total ?? fatura.valor)}
                                        </Text>
                                    </div>
                                </List.Item>
                            )}
                        />
                    )}
                </Card>
                )}

                {(() => {
                    const plano = dashboardData.planejamento || {};
                    const renda = plano.renda_mes || {};
                    const orc = plano.orcamento_50_30_20 || {};
                    const posso = plano.posso_guardar || {};
                    const fat = plano.meta_faturamento;
                    const anual = plano.resumo_anual_poupanca || {};
                    const mesRaw = selectedDate.format('MMMM / YYYY');
                    const mesLabel = mesRaw.charAt(0).toUpperCase() + mesRaw.slice(1);
                    const baseOrc = Number(orc.base) || 0;
                    const despesasReal = Number(orc.despesas_realizadas) || 0;
                    const poupancaReal = Number(orc.poupanca_realizada) || 0;
                    const necAlvo = Number(orc.necessidades_alvo) || 0;
                    const desAlvo = Number(orc.desejos_alvo) || 0;
                    const pouAlvo = Number(orc.poupanca_alvo) || 0;
                    const gastosVsNecessidadesDesejos = necAlvo + desAlvo;
                    const pctGastos = gastosVsNecessidadesDesejos > 0
                        ? Math.min(100, (despesasReal / gastosVsNecessidadesDesejos) * 100)
                        : 0;
                    const pctPoupanca = pouAlvo > 0
                        ? Math.min(100, (poupancaReal / pouAlvo) * 100)
                        : 0;
                    const sobra = Number(posso.sobra_estimada) || 0;
                    const aporteSug = Number(posso.aporte_sugerido) || 0;
                    const fatPct = Math.min(100, Number(fat?.percentual) || 0);

                    const openFaturamentoModal = () => {
                        formFaturamento.setFieldsValue({
                            valor_alvo: fat?.valor_alvo != null ? Number(fat.valor_alvo) : null,
                        });
                        setModalFaturamentoOpen(true);
                    };

                    const salvarFaturamento = async () => {
                        try {
                            const values = await formFaturamento.validateFields();
                            setSavingFaturamento(true);
                            await createOrUpdateMetaFaturamento(fat?.id || null, {
                                valor_alvo: values.valor_alvo,
                            });
                                            message.success('Meta de faturamento salva.');
                            setModalFaturamentoOpen(false);
                            setSelectedDate((d) => d.clone());
                        } catch (err) {
                            if (err?.errorFields) return;
                            message.error(getErrorMessage(err, 'Não foi possível salvar a meta.'));
                        } finally {
                            setSavingFaturamento(false);
                        }
                    };

                    const showRenda = cardVisivel('renda_mes');
                    const show503020 = cardVisivel('distribuicao_503020');
                    const showFat = temModoPrestador && cardVisivel('meta_faturamento');
                    const showAnual = cardVisivel('guardado_ano');
                    const showMetas = cardVisivel('metas_progresso');
                    const metasResumo = dashboardData.metas_poupanca_resumo || {};
                    const anyPlanejamento = showRenda || show503020 || showMetas || showFat || showAnual;
                    // "Quanto guardei no ano" fecha a grade: meia largura se sobrar um card sozinho
                    const qtdAntesAnual = [showRenda, show503020, showMetas, showFat].filter(Boolean).length;

                    return (
                        <>
                            {anyPlanejamento && (
                            <Title level={5} style={{ marginTop: 32, marginBottom: 16 }}>
                                Planejamento do mês
                            </Title>
                            )}
                            {anyPlanejamento && (
                            <Row gutter={[16, 16]} style={{ marginBottom: 24 }} className="planejamento-grid">
                                {showRenda && (
                                <Col xs={24} lg={12}>
                                    <Card
                                        className="planejamento-card"
                                        title={
                                            <TitleWithHelp
                                                help="Receitas do mês (já pagas, pendentes e recorrências projetadas, sem transferências entre contas) menos os compromissos do mês. A sugestão de aporte é só um lembrete — você confirma em Metas."
                                            >
                                                {`Renda e sobra de ${mesLabel}`}
                                            </TitleWithHelp>
                                        }
                                        style={{ height: '100%' }}
                                    >
                                        <MetricRows
                                            items={[
                                                {
                                                    label: 'Já recebido',
                                                    value: isPrivate ? '****' : formatCurrency(renda.recebido || 0),
                                                    color: '#2F9E6F',
                                                },
                                                {
                                                    label: 'A receber',
                                                    value: isPrivate ? '****' : formatCurrency(renda.a_receber || 0),
                                                    color: '#d48806',
                                                },
                                                {
                                                    label: 'Total esperado',
                                                    value: isPrivate ? '****' : formatCurrency(renda.total_esperado || 0),
                                                },
                                            ]}
                                        />
                                        <Divider style={{ margin: '12px 0' }} />
                                        <MetricRows
                                            items={[
                                                {
                                                    label: 'Compromissos',
                                                    value: isPrivate ? '****' : formatCurrency(posso.compromissos || 0),
                                                },
                                                {
                                                    label: 'Sobra estimada',
                                                    value: isPrivate ? '****' : formatCurrency(sobra),
                                                    color: sobra >= 0 ? '#2F9E6F' : '#D64545',
                                                },
                                            ]}
                                        />
                                        {!isPrivate && aporteSug > 0 && (
                                            <div className="planejamento-sugestao">
                                                <div style={{ fontSize: 13, marginBottom: 8 }}>
                                                    Aporte sugerido até {formatCurrency(aporteSug)}
                                                    {posso.meta_sugerida_nome
                                                        ? ` em “${posso.meta_sugerida_nome}”`
                                                        : ''}{' '}
                                                    — você confirma em Metas (não move dinheiro sozinho).
                                                </div>
                                                <Button
                                                    type="primary"
                                                    size="small"
                                                    onClick={() => navigate('/metas?aba=poupanca')}
                                                >
                                                    Ir para Metas
                                                </Button>
                                            </div>
                                        )}
                                        {!isPrivate && aporteSug <= 0 && (
                                            <div style={{ marginTop: 12, fontSize: 13, color: 'var(--color-text-secondary, #5A6A6A)' }}>
                                                Neste mês a sobra estimada não sugere aporte.
                                            </div>
                                        )}
                                        {!isPrivate && (renda.itens || []).length > 0 && (
                                            <Text strong style={{ display: 'block', marginTop: 16, fontSize: 13 }}>
                                                De onde vem a renda
                                            </Text>
                                        )}
                                        {!isPrivate && (renda.itens || []).length > 0 && (
                                            <List
                                                size="small"
                                                className="planejamento-renda-lista"
                                                style={{ marginTop: 4, maxHeight: 200, overflow: 'auto' }}
                                                dataSource={renda.itens.slice(0, 8)}
                                                renderItem={(item) => (
                                                    <List.Item className="planejamento-renda-item">
                                                        <div className="planejamento-renda-item-main">
                                                            <Text ellipsis className="planejamento-renda-desc">
                                                                {item.descricao}
                                                                {item.origem ? ` · ${item.origem}` : ''}
                                                                {item.projetado ? ' · projetado' : ''}
                                                            </Text>
                                                            <div className="planejamento-renda-item-meta">
                                                                <Text strong>
                                                                    {formatCurrency(item.valor)}
                                                                </Text>
                                                                <Tag
                                                                    color={item.status === 'recebido' ? 'success' : 'warning'}
                                                                    style={{ marginInlineEnd: 0 }}
                                                                >
                                                                    {item.status === 'recebido'
                                                                        ? 'Recebido'
                                                                        : item.data
                                                                          ? `A receber · ${dayjs(item.data).format('DD/MM')}`
                                                                          : 'A receber'}
                                                                </Tag>
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        )}
                                        {!isPrivate && !(renda.itens || []).length && (
                                            <div style={{ marginTop: 12, color: 'var(--color-text-secondary, #5A6A6A)', fontSize: 13 }}>
                                                Nenhuma receita prevista neste mês.
                                            </div>
                                        )}
                                    </Card>
                                </Col>
                                )}

                                {show503020 && (
                                <Col xs={24} lg={12}>
                                    <Card
                                        className="planejamento-card"
                                        title={
                                            <TitleWithHelp
                                                help="Sugestão clássica sobre a renda esperada do mês: 50% necessidades, 30% desejos e 20% poupança. Não move dinheiro automaticamente."
                                            >
                                                Distribuição 50/30/20
                                            </TitleWithHelp>
                                        }
                                        style={{ height: '100%' }}
                                    >
                                        <div className="planejamento-bar-503020" aria-hidden>
                                            <div style={{ width: '50%', background: '#50B0A0' }} />
                                            <div style={{ width: '30%', background: '#fa8c16' }} />
                                            <div style={{ width: '20%', background: '#2F9E6F' }} />
                                        </div>
                                        <MetricRows
                                            items={[
                                                {
                                                    label: 'Necessidades 50%',
                                                    value: isPrivate ? '****' : formatCurrency(necAlvo),
                                                    dot: '#50B0A0',
                                                },
                                                {
                                                    label: 'Desejos 30%',
                                                    value: isPrivate ? '****' : formatCurrency(desAlvo),
                                                    dot: '#fa8c16',
                                                },
                                                {
                                                    label: 'Poupança 20%',
                                                    value: isPrivate ? '****' : formatCurrency(pouAlvo),
                                                    color: '#2F9E6F',
                                                    dot: '#2F9E6F',
                                                },
                                            ]}
                                        />
                                        {!isPrivate && baseOrc > 0 && (
                                            <div className="planejamento-progressos" style={{ marginTop: 16 }}>
                                                <div className="planejamento-progress-label">
                                                    <span>Despesas vs necessidades + desejos</span>
                                                    <span>{formatCurrency(despesasReal)}</span>
                                                </div>
                                                <Progress
                                                    percent={Math.round(pctGastos)}
                                                    strokeColor="#50B0A0"
                                                    showInfo={false}
                                                    size="small"
                                                />
                                                <div className="planejamento-progress-label" style={{ marginTop: 12 }}>
                                                    <span>Guardado vs poupança 20%</span>
                                                    <span>{formatCurrency(poupancaReal)}</span>
                                                </div>
                                                <Progress
                                                    percent={Math.round(pctPoupanca)}
                                                    strokeColor="#2F9E6F"
                                                    showInfo={false}
                                                    size="small"
                                                />
                                            </div>
                                        )}
                                    </Card>
                                </Col>
                                )}

                                {showMetas && (
                                <Col xs={24} lg={12}>
                                    <Card
                                        className="planejamento-card"
                                        title={
                                            <TitleWithHelp help="Soma do valor alocado nas caixinhas ÷ soma dos valores-alvo das metas ativas.">
                                                Metas de poupança
                                            </TitleWithHelp>
                                        }
                                        extra={
                                            <Button
                                                type="link"
                                                size="small"
                                                onClick={() => navigate('/metas?aba=poupanca')}
                                                style={{ padding: 0 }}
                                            >
                                                Ver metas
                                            </Button>
                                        }
                                        style={{ height: '100%' }}
                                    >
                                        {metasResumo.qtd ? (
                                            <>
                                                <div className="planejamento-progress-label">
                                                    <span>
                                                        {isPrivate ? '****' : `${Number(metasResumo.percentual_geral || 0).toFixed(1)}% do alvo`}
                                                    </span>
                                                    <span>
                                                        {isPrivate
                                                            ? '****'
                                                            : `${formatCurrency(metasResumo.total_atual)} / ${formatCurrency(metasResumo.total_alvo)}`}
                                                    </span>
                                                </div>
                                                <Progress
                                                    percent={Math.min(100, Math.round(Number(metasResumo.percentual_geral) || 0))}
                                                    strokeColor="#2F9E6F"
                                                    showInfo={false}
                                                    size="small"
                                                />
                                                <div style={{ marginTop: 12, fontSize: 13, color: 'var(--color-text-secondary, #5A6A6A)' }}>
                                                    {metasResumo.qtd} meta{metasResumo.qtd === 1 ? '' : 's'} ativa{metasResumo.qtd === 1 ? '' : 's'}
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{ color: 'var(--color-text-secondary, #5A6A6A)', fontSize: 13 }}>
                                                Crie um objetivo em Metas → Juntar dinheiro para acompanhar o progresso aqui.
                                            </div>
                                        )}
                                    </Card>
                                </Col>
                                )}

                                {showFat && (
                                <Col xs={24} lg={12}>
                                    <Card
                                        className="planejamento-card"
                                        title={
                                            <TitleWithHelp
                                                help="Alvo mensal de faturamento. Já recebido = receitas pagas; a receber = pendentes e projetadas (sem transferências)."
                                            >
                                                Meta de faturamento
                                            </TitleWithHelp>
                                        }
                                        extra={
                                            <Button
                                                type="link"
                                                size="small"
                                                onClick={openFaturamentoModal}
                                                style={{ padding: 0 }}
                                            >
                                                {fat ? 'Editar' : 'Definir'}
                                            </Button>
                                        }
                                        style={{ height: '100%' }}
                                    >
                                        {fat ? (
                                            <>
                                                <div className="planejamento-progress-label">
                                                    <span>{isPrivate ? '****' : `${Math.round(fatPct)}% recebido`}</span>
                                                    <span>
                                                        {isPrivate
                                                            ? '****'
                                                            : `${formatCurrency(fat.valor_recebido)} / ${formatCurrency(fat.valor_alvo)}`}
                                                    </span>
                                                </div>
                                                <Progress
                                                    percent={Math.round(fatPct)}
                                                    strokeColor="#2F9E6F"
                                                    showInfo={false}
                                                    size="small"
                                                />
                                                <div style={{ marginTop: 12 }}>
                                                    <MetricRows
                                                        items={[
                                                            {
                                                                label: 'Já recebido',
                                                                value: isPrivate
                                                                    ? '****'
                                                                    : formatCurrency(fat.valor_recebido),
                                                                color: '#2F9E6F',
                                                            },
                                                            {
                                                                label: 'A receber',
                                                                value: isPrivate
                                                                    ? '****'
                                                                    : formatCurrency(
                                                                        fat.valor_a_receber != null
                                                                            ? fat.valor_a_receber
                                                                            : renda.a_receber || 0,
                                                                    ),
                                                                color: '#d48806',
                                                            },
                                                            {
                                                                label: 'Alvo do mês',
                                                                value: isPrivate
                                                                    ? '****'
                                                                    : formatCurrency(fat.valor_alvo),
                                                            },
                                                        ]}
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{ color: 'var(--color-text-secondary, #5A6A6A)', fontSize: 13 }}>
                                                Defina um alvo mensal de faturamento. O card mostra já recebido, a receber e o alvo.
                                            </div>
                                        )}
                                    </Card>
                                </Col>
                                )}

                                {showAnual && (
                                <Col xs={24} lg={qtdAntesAnual % 2 === 1 ? 12 : 24}>
                                    <Card
                                        className="planejamento-card"
                                        title={
                                            <TitleWithHelp
                                                help="Soma dos aportes nas metas de poupança no ano civil, menos resgates registrados. Complementa a evolução de patrimônio."
                                            >
                                                Quanto guardei no ano
                                            </TitleWithHelp>
                                        }
                                        extra={
                                            <Text type="secondary">{anual.ano || selectedDate.year()}</Text>
                                        }
                                    >
                                        <MetricRows
                                            items={[
                                                {
                                                    label: 'Aportes no ano',
                                                    value: isPrivate
                                                        ? '****'
                                                        : formatCurrency(anual.aportes || 0),
                                                    color: '#2F9E6F',
                                                },
                                                {
                                                    label: 'Resgates',
                                                    value: isPrivate
                                                        ? '****'
                                                        : formatCurrency(anual.resgates || 0),
                                                },
                                                {
                                                    label: 'Líquido guardado',
                                                    value: isPrivate
                                                        ? '****'
                                                        : formatCurrency(anual.liquido || 0),
                                                    color:
                                                        Number(anual.liquido) >= 0 ? '#2F9E6F' : '#D64545',
                                                },
                                            ]}
                                        />
                                    </Card>
                                </Col>
                                )}
                            </Row>
                            )}

                            <Modal
                                title="Meta de faturamento"
                                open={modalFaturamentoOpen}
                                onCancel={() => setModalFaturamentoOpen(false)}
                                onOk={salvarFaturamento}
                                confirmLoading={savingFaturamento}
                                okText="Salvar"
                                destroyOnClose
                            >
                                <Form form={formFaturamento} layout="vertical">
                                    <Form.Item
                                        name="valor_alvo"
                                        label="Valor alvo mensal"
                                        rules={[{ required: true, message: 'Informe o valor alvo' }]}
                                    >
                                        <InputNumber {...currencyInputProps({ min: 0.01 })} />
                                    </Form.Item>
                                    <Text type="secondary">
                                        O progresso usa as receitas do mês (excluindo transferências). Nada é movido automaticamente.
                                    </Text>
                                </Form>
                            </Modal>
                        </>
                    );
                })()}
            </>
        );
    };

    const renderMilhasContent = () => {
        const totalMilhas = desempenhoMilhas.reduce((acc, curr) => acc + parseFloat(curr.saldo_atual), 0);
        const totalInvestido = desempenhoMilhas.reduce((acc, curr) => acc + parseFloat(curr.valor_patrimonial_custo), 0);
        const cpmGeral = totalMilhas > 0 ? (totalInvestido / totalMilhas) * 1000 : 0;
        const totalLucroVendas = desempenhoMilhas.reduce((acc, curr) => acc + (parseFloat(curr.lucro_vendas) || 0), 0);

        return (
            <div>
                <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'flex-end' }}>
                    <Select
                        value={selectedPortadorId}
                        onChange={(value) => setSelectedPortadorId(value)}
                        style={{ width: isMobile ? '100%' : 240 }} // Adaptado para mobile
                        loading={loading}
                    >
                        <Option value="todos">Todos os Portadores</Option>
                        {portadores.map(p => (
                            <Option key={p.id} value={p.id}>{p.nome_completo}</Option>
                        ))}
                    </Select>
                </div>

                {loadingMilhas ? (
                    <div className="brand-skeleton" aria-busy="true" aria-label="Carregando milhas">
                        <div className="brand-skeleton-line brand-skeleton-line--lg" />
                        <div className="brand-skeleton-line brand-skeleton-line--md" />
                        <div className="brand-skeleton-line" />
                    </div>
                ) : !desempenhoMilhas || desempenhoMilhas.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '50px' }}>Não há programas com saldo para o portador selecionado.</div>
                ) : (
                    <>
                        {cardVisivel('milhas_recebiveis') && (
                        <ResumoRecebiveisMilhas dados={recebiveisMilhas} loading={loadingMilhas} isPrivate={isPrivate} isMobile={isMobile} />
                        )}

                        {cardVisivel('milhas_resumo') && (
                        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                            <Col xs={24} sm={12} md={6}>
                                <Card bordered={false} style={{ background: 'rgba(31, 79, 79, 0.08)', borderColor: 'rgba(31, 79, 79, 0.22)' }}>
                                    <Statistic
                                        title={<Space><BankOutlined /> Patrimônio em Milhas (Custo)</Space>}
                                        value={totalInvestido}
                                        formatter={formatCurrency}
                                        valueStyle={{ color: '#2F6B6B', fontWeight: 'bold' }}
                                    />
                                    <Text type="secondary" style={{ fontSize: 12 }}>Valor total investido acumulado</Text>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card bordered={false} style={{ background: 'rgba(80, 176, 160, 0.12)', borderColor: 'rgba(80, 176, 160, 0.35)' }}>
                                    <Statistic
                                        title={<Space><RocketOutlined /> Saldo Total de Milhas</Space>}
                                        value={totalMilhas}
                                        formatter={formatNumber}
                                        suffix=" pts"
                                        valueStyle={{ color: '#50B0A0', fontWeight: 'bold' }}
                                    />
                                    <Text type="secondary" style={{ fontSize: 12 }}>Soma de todos os programas</Text>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card bordered={false} style={{ background: 'rgba(184, 144, 64, 0.12)', borderColor: 'rgba(184, 144, 64, 0.35)' }}>
                                    <Statistic
                                        title={<Space><RiseOutlined /> CPM Médio Geral</Space>}
                                        value={cpmGeral}
                                        formatter={formatCurrency}
                                        valueStyle={{ color: '#E6A23C', fontWeight: 'bold' }}
                                    />
                                    <Text type="secondary" style={{ fontSize: 12 }}>Se vender acima disso, você tem lucro</Text>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Card bordered={false} style={{
                                    background: totalLucroVendas >= 0 ? '#f6ffed' : '#fff2f0',
                                    borderColor: totalLucroVendas >= 0 ? '#b7eb8f' : '#ffccc7'
                                }}>
                                    <Statistic
                                        title={<Space><DollarCircleOutlined /> Resultado com Vendas de Milhas</Space>}
                                        value={totalLucroVendas}
                                        formatter={(v) => (isPrivate ? '****' : formatCurrency(v))}
                                        valueStyle={{
                                            color: totalLucroVendas >= 0 ? '#2F9E6F' : '#D64545',
                                            fontWeight: 'bold'
                                        }}
                                    />
                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                        {totalLucroVendas >= 0 ? 'Lucro' : 'Prejuízo'} realizados nas vendas registradas
                                    </Text>
                                </Card>
                            </Col>
                        </Row>
                        )}

                        {cardVisivel('milhas_programas') && (
                        <>
                        <Divider orientation="left">Detalhe por Programa</Divider>

                        <Row gutter={[16, 16]}>
                            {/* Uso da Lista Ordenada */}
                            {programasOrdenados.map(programa => (
                                <Col xs={24} sm={12} lg={6} key={programa.id_programa_portador}>
                                    <Card className="milhas-programa-card" bodyStyle={{ padding: 16, position: 'relative', minHeight: 140 }}>
                                        <div className="milhas-programa-card-header">
                                            <Text
                                                strong
                                                ellipsis={{ tooltip: programa.programa_nome }}
                                                className="milhas-programa-card-title"
                                            >
                                                {programa.programa_nome}
                                            </Text>
                                            <div className="milhas-programa-card-actions">
                                                <AntdTooltip title={programa.portador_nome}>
                                                    <Tag
                                                        color="geekblue"
                                                        className="milhas-programa-portador-tag"
                                                    >
                                                        {programa.portador_nome.toUpperCase()}
                                                    </Tag>
                                                </AntdTooltip>
                                            </div>
                                        </div>

                                        <Row gutter={[12, 12]} align="top" wrap={false}>
                                            <Col className="milhas-programa-logo">
                                                <LogoManager slug={programa.programa_slug} type="programa" style={{ width: 56, height: 56 }} />
                                            </Col>
                                            <Col flex="auto" className="milhas-programa-info" style={{ minWidth: 0 }}>
                                                <Statistic
                                                    title="Saldo"
                                                    value={programa.saldo_atual}
                                                    formatter={formatNumber}
                                                    suffix=" pts"
                                                    valueStyle={{ fontSize: '1.25rem', lineHeight: 1.2 }}
                                                />
                                                <Row gutter={[8, 6]} className="milhas-programa-cpm-patrimonio">
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Statistic
                                                            title="CPM"
                                                            value={programa.custo_medio_milheiro}
                                                            formatter={formatCurrency}
                                                            valueStyle={{ fontSize: '0.85rem' }}
                                                            style={{ lineHeight: 1 }}
                                                        />
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Statistic
                                                            title="Patrimônio"
                                                            value={programa.valor_patrimonial_custo}
                                                            formatter={formatCurrency}
                                                            valueStyle={{ fontSize: '0.85rem', color: '#2F9E6F' }}
                                                            style={{ lineHeight: 1 }}
                                                        />
                                                    </Col>
                                                    <Col xs={24}>
                                                        <Statistic
                                                            title="Resultado vendas"
                                                            value={programa.lucro_vendas ?? 0}
                                                            formatter={(v) => (isPrivate ? '****' : formatCurrency(v))}
                                                            valueStyle={{
                                                                fontSize: '0.85rem',
                                                                color: (programa.lucro_vendas ?? 0) >= 0 ? '#2F9E6F' : '#D64545'
                                                            }}
                                                            style={{ lineHeight: 1 }}
                                                        />
                                                    </Col>
                                                    {/* CPFs utilizados */}
                                                    {(() => {
                                                        const cpfInfo = cpfDataByPrograma?.[programa.id_programa_portador];
                                                        if (!cpfInfo) return null;
                                                        const semLimite = !cpfInfo.limite_cpfs || cpfInfo.limite_cpfs === 0;
                                                        return (
                                                            <Col xs={24}>
                                                                {semLimite ? (
                                                                    <AntdTooltip title="Sem limite oficial; apenas monitorando uso.">
                                                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                                                            CPFs: {cpfInfo.cpfs_usados} utilizados (apenas monitorar)
                                                                        </Text>
                                                                    </AntdTooltip>
                                                                ) : (
                                                                    <AntdTooltip title={cpfInfo.cpfs_usados > 0
                                                                        ? `Passageiros: ${(cpfInfo.passageiros || []).map((p) => (typeof p === 'string' ? p : (p?.nome || p?.cpf || ''))).filter(Boolean).slice(0, 8).join(', ')}${(cpfInfo.passageiros?.length || 0) > 8 ? '…' : ''} (${cpfInfo.passageiros?.length || 0} CPF(s))`
                                                                        : ''
                                                                    }>
                                                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                                                            CPFs: {cpfInfo.cpfs_usados}/{cpfInfo.limite_cpfs} utilizados ({cpfInfo.cpfs_restantes} restantes)
                                                                        </Text>
                                                                    </AntdTooltip>
                                                                )}
                                                            </Col>
                                                        );
                                                    })()}
                                                </Row>
                                            </Col>
                                        </Row>

                                        {Number(programa.milhas_a_receber) > 0 && programa.portador_id && programa.id_programa_portador ? (
                                            <button
                                                type="button"
                                                className="milhas-programa-a-receber"
                                                onClick={() => navigate(
                                                    `/portadores/${programa.portador_id}/programas/${programa.id_programa_portador}/extrato?filtro=a_receber`
                                                )}
                                            >
                                                <ScheduleOutlined className="milhas-programa-a-receber-icon" />
                                                <span className="milhas-programa-a-receber-label">A receber</span>
                                                <span className="milhas-programa-a-receber-value">
                                                    {isPrivate ? '****' : `${formatNumber(programa.milhas_a_receber)} pts`}
                                                </span>
                                                <span className="milhas-programa-a-receber-cta">ver</span>
                                            </button>
                                        ) : null}
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                        </>
                        )}
                    </>
                )}
            </div>
        );
    };

    return (
        <div className="dashboard-container" style={{ padding: isMobile ? '10px' : '24px' }}>
            {/* Header: Container simples para forçar empilhamento vertical (Título em cima, Menu embaixo) */}
            <div style={{ marginBottom: isMobile ? '16px' : '24px' }}>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 12,
                    marginBottom: 16,
                }}>
                    <Title level={isMobile ? 3 : 2} style={{ margin: 0 }}>{pageTitle}</Title>
                    <Button icon={<AppstoreOutlined />} onClick={openPersonalizar}>
                        Personalizar
                    </Button>
                </div>

                <PrimeirosPassosCard />
                <ModoPrestadorBanner />
                
                {/* Abas no estilo card (igual à tela de Relatórios) */}
                {temModuloFinanceiro && temModuloMilhas ? (
                <Tabs activeKey={activeTab} onChange={handleTabChange} size="middle" type="card" className="sa-page-tabs">
                    <Tabs.TabPane tab={<span><DollarCircleOutlined /> Financeiro</span>} key="Financeiro">
                        {renderFinanceiroToolbar()}
                        {renderFinanceiroContent()}
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={<span><StarOutlined /> Milhas</span>} key="Milhas">
                        {renderMilhasContent()}
                    </Tabs.TabPane>
                </Tabs>
                ) : temModuloFinanceiro ? (
                    <>
                        {renderFinanceiroToolbar()}
                        {renderFinanceiroContent()}
                    </>
                ) : temModuloMilhas ? (
                    renderMilhasContent()
                ) : null}
            </div>

            <DesempenhoFiltrosModal
                open={filtrosOpen}
                onClose={() => setFiltrosOpen(false)}
                onSave={salvarFiltros}
                saving={savingFiltros}
                value={filtrosDesempenho}
                cartoes={cartoesLista}
                adicionais={adicionaisLista}
                isMobile={isMobile}
            />

            <Modal
                title="Personalizar cards"
                open={personalizarOpen}
                onCancel={() => setPersonalizarOpen(false)}
                onOk={salvarPersonalizar}
                confirmLoading={savingPersonalizar}
                okText="Salvar"
                cancelText="Cancelar"
                width={isMobile ? '100%' : 520}
                destroyOnClose
                footer={[
                    <Button key="restore" onClick={restaurarPadraoPersonalizar} disabled={savingPersonalizar}>
                        Restaurar padrão
                    </Button>,
                    <Button key="cancel" onClick={() => setPersonalizarOpen(false)}>
                        Cancelar
                    </Button>,
                    <Button key="ok" type="primary" loading={savingPersonalizar} onClick={salvarPersonalizar}>
                        Salvar
                    </Button>,
                ]}
            >
                <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                    Escolha quais cards aparecem em Meu Desempenho. A preferência sincroniza entre web e app.
                </Text>
                {DESEMPENHO_CARD_GROUPS.filter((group) => {
                    if (group.id === 'milhas') return temModuloMilhas;
                    return temModuloFinanceiro;
                }).map((group) => (
                    <div key={group.id} style={{ marginBottom: 20 }}>
                        <Text strong style={{ display: 'block', marginBottom: 8 }}>{group.label}</Text>
                        <Space direction="vertical" style={{ width: '100%' }} size={8}>
                            {group.cards
                                .filter((card) => card.id !== 'meta_faturamento' || temModoPrestador)
                                .map((card) => (
                                <div
                                    key={card.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 12,
                                    }}
                                >
                                    <Text>{card.label}</Text>
                                    <Switch
                                        checked={draftCards[card.id] !== false}
                                        onChange={(checked) => toggleDraftCard(card.id, checked)}
                                    />
                                </div>
                            ))}
                        </Space>
                    </div>
                ))}
            </Modal>
        </div>
    );
}

export default MeuDesempenhoPage;